import  { use, useEffect, useState } from "react";
import EmailVerification from "./EmailVerification";
import PhoneVerification from "./PhoneVerification";
import AddressVerification from "./AddressVerification";
import { useNavigate } from "react-router";
import BvnVerification from "./BvnVerification";
import SetPinVerification from "./SetPinVerification";
import { useDispatch } from "react-redux";
import { CurrentUser } from "../../../utils/redux/Auth/AuthSlice";

const KYCLevelOneDetails = ({
  onBack,
  data,
  reload,
  setReload,
  setShowLevelOneDetails,
  setShowLevelTwoDetails,
}) => {
  const [step, setStep] = useState("requirements");
  const dispatch = useDispatch();
  const [refresh, setRefresh] = useState(false);

  // State for loading and error handling
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const { onboardingProgress, onboardingStatus } = data;
  const { pendingItems } = onboardingProgress || {};

  // Log for debugging
  console.log("onboardingProgress:", onboardingProgress);

  const proceedToNextStep = (requirement) => {
    if (requirement && requirement.item) {
      setStep(requirement.item); // Set the step dynamically based on the requirement
    }
  };

  const fetchUserData = async () => {
    try {
      setIsLoading(true);
      await dispatch(CurrentUser());
      setIsLoading(false);
    } catch (error) {
      setError("Error loading user data. Please try again.");
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, [dispatch, refresh]);

  useEffect(() => {
    if (onboardingStatus !== "Level 1") {
      onBack(); // This will reset the detail views
      setShowLevelOneDetails(false); // Close Level One
      setShowLevelTwoDetails(true); // Show Level Two
    } else if (pendingItems?.length === 0) {
      onBack(); // This will reset the detail views
      setShowLevelOneDetails(false); // Close Level One
      setShowLevelTwoDetails(true); // Show Level Two
    }
  }, [pendingItems, onBack, setShowLevelOneDetails, setShowLevelTwoDetails]);

  // Conditional rendering based on the current step
  if (step === "email_verification") {
    return (
      <EmailVerification
        data={data}
        onBack={() => setStep("requirements")}
        refresh={reload}
        setRefresh={setReload}
      />
    );
  }

  if (step === "phone_verification") {
    return (
      <PhoneVerification
        data={data}
        onBack={() => setStep("requirements")}
        refresh={reload}
        setRefresh={setReload}
      />
    );
  }

  if (step === "upload_address") {
    return (
      <AddressVerification
        data={data}
        onBack={() => setStep("requirements")}
        refresh={reload}
        setRefresh={setReload}
      />
    );
  }

  if (step === "bvn_verification") {
    return (
      <BvnVerification
        data={data}
        onBack={() => setStep("requirements")}
        refresh={reload}
        setRefresh={setReload}
      />
    );
  }

  if (step === "transaction_pin") {
    return (
      <SetPinVerification
        data={data}
        onBack={() => setStep("requirements")}
        refresh={reload}
        setRefresh={setReload}
      />
    );
  }

  return (
    <div className="w-full md:w-[650px] mx-auto p-4">
      <button onClick={onBack} className="text-blue-600 text-sm mb-4">
        Back
      </button>
      <h3 className="text-xl font-semibold text-gray-800 mb-4">
        Level One KYC Details
      </h3>
      <div className="bg-primary-color text-white text-lg rounded-lg px-6 py-4 flex justify-between items-center my-[50px]">
        <span>Verification Requirements</span>
        {pendingItems?.length > 0 && (
          <button
            onClick={() => proceedToNextStep(pendingItems[0])}
            className="bg-white text-primary-color font-semibold px-8 py-4 rounded-md"
          >
            Proceed
          </button>
        )}
      </div>
      <div className="border border-gray-300 rounded-b-lg">
        {pendingItems?.map((requirement, index) => (
          <div
            key={index}
            className="flex items-center px-4 py-8 border-b border-gray-200"
          >
            <div className="w-6 h-6 flex items-center justify-center rounded-full border-2 border-deeper-blue mr-4">
              <div className="w-3 h-3 rounded-full bg-deeper-blue"></div>
            </div>
            <span className="text-gray-700 capitalize">
              {requirement?.item?.replace("_", " ")}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default KYCLevelOneDetails;
